import React from 'react';
import { Modal, ModalHeader, ModalBody } from 'reactstrap';
import StyledButton from '../Common/StyledButton';

const ImportModal = ({
  isOpen,
  toggle,
  title,
  fileInputRef,
  handleFileUpload,
  handleButtonClick,
  isUploading,
  templateUrl,
  templateName,
  supportedFormat = 'CSV',
}) => {
  return (
    <Modal isOpen={isOpen} toggle={toggle} centered>
      <ModalHeader toggle={toggle}>
        {title}
      </ModalHeader>

      <ModalBody>
        <div className="border-2 border-dashed border-gray-300 rounded-lg p-6 text-center bg-gray-50 hover:bg-gray-100 transition-all">
          <div className="flex justify-center mb-3">
            <i className="mdi mdi-cloud-upload-outline text-5xl text-gray-400"></i>
          </div>

          <h5 className="font-medium text-gray-700">
            Click below to browse
          </h5>

          <input
            type="file"
            ref={fileInputRef}
            style={{ display: 'none' }}
            onChange={handleFileUpload}
          />

          <StyledButton
            color="primary"
            className="w-md"
            onClick={handleButtonClick}
            isLoading={isUploading}
          >
            <i className="ion ion-md-cloud-upload mx-2"></i>
            Import
          </StyledButton>

          <p className="text-xs text-gray-400 mt-3">
            Supported format: {supportedFormat}
          </p>
        </div>

        <div className="mt-4 text-center border-top pt-4">
          <StyledButton color="primary">
            <a
              href={templateUrl}
              download
              className="text-white text-decoration-none"
            >
              <i className="ion ion-md-cloud-download mx-2"></i>
              Download Template
            </a>
          </StyledButton>

          <p className="text-sm text-gray-500 mt-3">
            Download the {templateName} template and ensure your file matches it
            before importing.
          </p>
        </div>
      </ModalBody>
    </Modal>
  );
};

export default ImportModal;